import React, { Component } from 'react';
import { withRouter } from 'utilities/with_router';
import { ResourceWindow } from 'components';
import submit_button from 'icons/submit_login_white.png';
import login_spinner from 'icons/submit_login_spinner.png';
import { useAuth } from 'auth_context';

class LoginPage extends Component {
	constructor(props) {
		super(props);

		this.state = {
			username: '',
			password: '',
			login_display: true,
			login_text_display: true,
			login_text_class: 'text_appearing1',
			login_text_animation: '',
			login_fields_animation: '',
			submit_button: submit_button,
			submit_button_animation: '',
			app_window_animation: '',
			failed_login: false,
			resources: [],
		};
	}

	componentDidMount() {}

	hideLogin = () => {
		this.setState({
			login_fields_animation: 'fade-out 1s forwards',
			login_text_animation: 'fade-out 1s forwards',
		});
		setTimeout(() => {
			this.setState({ login_display: false, login_text_display: false });
		}, 1000);
	};

	animateLogin = () => {
		this.setState({
			submit_button: login_spinner,
			submit_button_animation: 'spin-animation',
		});
	};

	removeLoginAnimation = () => {
		this.setState({
			submit_button: submit_button,
			submit_button_animation: '',
		});
	};

	showFailedLogin = () => {
		this.setState({
			failed_login: true,
		});
	};

	hideFailedLogin = () => {
		this.setState({
			failed_login: false,
		});
	};

	loginUser = async () => {
		this.animateLogin();
		let url = '/api/login/';

		try {
			const data = await this.props.auth.login(this.state.username, this.state.password);

			this.removeLoginAnimation();

			if (data['authenticated']) {
				this.hideFailedLogin();
				this.props.navigate('/org_portal');
			} else {
				let error = data['error'];
				this.showFailedLogin(error);
			}
		} catch (error) {
			console.error('Network error:', error);
			this.removeLoginAnimation();
		}
	};

	handleKeyDown = event => {
		if (event.key === 'Enter') {
			this.loginUser();
		}
	};

	render() {
		return (
			<div
				className="login-box"
				style={{
					display: this.state.login_display ? 'flex' : 'none',
					animation: this.state.login_fields_animation,
				}}
			>
				<form
					style={{
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						alignItems: 'center', // center horizontally
						gap: '12px', // consistent spacing between rows
					}}
				>
					{/* Heading */}
					<div
						className={`login-text ${this.state.login_text_class}`}
						style={{
							display: this.state.login_text_display ? 'flex' : 'none',
							animation: this.state.login_text_animation,
							justifyContent: 'center',
						}}
					>
						<h1>Login</h1>
					</div>

					<div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
						<img className="submit-button" />
						<input
							type="text"
							value={this.state.username}
							onChange={e => this.setState({ username: e.target.value })}
							className="login-fields"
							placeholder="username"
							autoComplete="username"
							onKeyDown={this.handleKeyDown}
						/>
						<img className="submit-button" />
					</div>

					<div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
						<img className="submit-button" />
						<input
							type="password"
							value={this.state.password}
							onChange={e => this.setState({ password: e.target.value })}
							className="login-fields"
							placeholder="password"
							autoComplete="current-password"
							onKeyDown={this.handleKeyDown}
						/>
						<img
							className={`submit-button ${this.state.submit_button_animation}`}
							onClick={this.loginUser}
							src={this.state.submit_button}
						/>
					</div>

					{/* Failed Login message */}
					<div
						style={{
							display: this.state.failed_login ? '' : 'none',
							animation: 'fade-in 1s forwards',
						}}
						className="failed-login-alert"
					>
						<p>Incorrect login.</p>
					</div>
				</form>
			</div>
		);
	}
}

const Login = props => {
	const auth = useAuth();

	return <LoginPage {...props} auth={auth} />;
};

export default withRouter(Login);
